<template>
  <hel-module title="供应商绩效分级" :class="scope.clsPrefix" v-loading="loading">
    <div class="chart-container">
      <div class="chart-main">
        <div class="chart-body-wrap">
          <div class="chart-center-text">
            <div class="center-value">{{ totalSuppliers }}家</div>
            <div class="center-label">活跃供应商</div>
          </div>
          <div id="supplierPerformanceChart" class="chart-body"></div>
        </div>
        <div class="grade-list">
          <div class="grade-item" v-for="(item, index) in gradeList" :key="index">
            <div class="item-header">
              <span class="grade-dot" :style="{ background: item.color }"></span>
              <span class="grade-name">{{ item.name }}</span>
            </div>
            <div class="grade-count">{{ item.count }}家 · {{ item.percent }}%</div>
          </div>
        </div>
      </div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from '../common/module/index.vue'
import * as echarts from 'echarts'
import { getSupplierGrade } from '@/api/procurement'

export default {
  name: 'SupplierPerformanceGrade',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-supplier-grade'
      },
      totalSuppliers: 0,
      evalPeriod: '--',
      gradeList: [],
      chartInstance: null
    }
  },
  mounted() {
    this.fetchData()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
      this.chartInstance = null
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const res = await getSupplierGrade()
        if (!res || res.code !== 200 || !res.data) {
          this.totalSuppliers = 0
          this.evalPeriod = '--'
          this.gradeList = []
          return
        }
        const data = res.data
        const colors = ['#8BC66C', '#7B8CDE', '#F0C070', '#E07070']
        this.totalSuppliers = data.totalSuppliers || 0
        this.evalPeriod = data.evalPeriod || '--'
        const grades = Array.isArray(data.grades) ? data.grades : []
        this.gradeList = grades.map((g, index) => ({
          name: g.gradeName,
          count: g.supplierCount,
          percent: g.percent,
          color: colors[index % colors.length]
        }))

        this.$nextTick(() => {
          this.drawChart()
        })
      } catch (error) {
        console.error('获取供应商绩效分级数据失败:', error)
        this.totalSuppliers = 0
        this.evalPeriod = '--'
        this.gradeList = []
      } finally {
        this.loading = false
      }
    },
    drawChart() {
      const chart = echarts.init(
        document.getElementById('supplierPerformanceChart')
      )
      const option = {
        tooltip: {
          trigger: 'item',
          confine: true,
          formatter: (p) =>
            `${p.name}<br/>${p.marker}数量: ${p.value}家<br/>占比: ${p.percent}%`
        },
        series: [
          {
            name: '供应商数量',
            type: 'pie',
            radius: ['65%', '100%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: this.gradeList.map((i) => ({
              value: i.count,
              name: i.name,
              itemStyle: { color: i.color }
            }))
          }
        ]
      }
      chart.setOption(option)
      this.chartInstance = chart
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.chartInstance && this.chartInstance.resize()
        })
        setTimeout(() => {
          this.chartInstance && this.chartInstance.resize()
        }, 200)
      })
    },
    handleResize() {
      if (this.chartInstance) {
        setTimeout(() => {
          this.chartInstance.resize()
        }, 200)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-supplier-grade";
.#{$class-prefix} {
  .chart-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .chart-main {
    flex: 1;
    display: flex;
    align-items: center;
    min-height: 0;
  }
  .chart-body-wrap {
    position: relative;
    width: 55%;
    height: 100%;
    min-height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .chart-center-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 1000;
    .center-label {
      font-family: PingFangSC-Medium;
      font-weight: 600;
      font-size: 11px;
      color: #333333;
    }
    .center-value {
      font-size: 18px;
      font-weight: 700;
      color: #333;
    }
  }
  .chart-body {
    width: 100%;
    height: 100%;
    min-height: 220px;
  }
  .grade-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 14px;
    padding-left: 12px;
    flex-shrink: 0;
    min-width: 40%;
  }
  .grade-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }
  .item-header {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .grade-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  .grade-name {
    font-size: 12px;
    color: #666666;
    font-weight: 400;
  }
  .grade-count {
    font-size: 12px;
    color: #333333;
    font-weight: 600;
  }
}
</style>
